import { Controller } from "shark-mvc";
import { NousCore } from "nouscore-js-api";
import Attachment from "../models/Attachment";

class ManagerBase extends Controller {
	constructor () {
		super("managerBase");
	}

	close (item) {
		const rd = NousCore.api.createRequest({ item: item.export() });
		const requestedAction = "close";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						item.import(data.items[0]);
						item.clean();

						return {
							data: item,
							requestedAction,
							status: "ok"
						};
					case 404:
						return {
							data,
							requestedAction,
							status: "ko"
						};
				}
			}
		});
	}

	delete (itemList) {
		if (!Array.isArray(itemList)) {
			itemList = [itemList];
		}

		const rd = NousCore.api.createRequest({ items: itemList.map(item => { return { guid: item.guid }; }) });
		const requestedAction = "delete";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			console.log(data);
	
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data,
							requestedAction,
							status: "ok",
						};
					case 404:
						return {
							data,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}

	getByGuid (guid) {
		const rd = NousCore.api.createRequest({item: { guid } });
		const requestedAction = "get-by-guid";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data: data.items,
							requestedAction,
							status: "ok"
						};
					case 404:
						return {
							data,
							requestedAction,
							status: "ko"
						};
				}
			}
		});
	}

	async getByGuidList (guidList) {
		const requestedAction = "get-by-guid-list";

		const rd = NousCore.api.createRequest({ item: { guidList } });

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data: data.items,
							requestedAction,
							status: "ok",
						};
					case 99:
						return {
							data,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}


	async getList (filters) {
		const rd = NousCore.api.createRequest({ filters });
		const requestedAction = "get-list";

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data: data.items,
							requestedAction,
							status: "ok",
						};
					case 99:
						return {
							data,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}

	async save (itemList) {
		let actions = new Set();

		if (!Array.isArray(itemList)) {
			itemList = [itemList];
		}

		itemList.forEach(item => {
			actions.add(item.guid === "" ? "insert" : "update");
		});

		if (actions.size > 1) {
			alert("Non posso preosuguire");
			return;
		}
		
		const rd = NousCore.api.createRequest({ items: itemList.map(item => item.export()) });
		// const rd = NousCore.api.createRequest({ item: itemList[0].export() });
		const requestedAction = Array.from(actions)[0];

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						itemList.forEach((item, index) => {
							item.import(data.items[index]);
							item.clean();
						});

						return {
							data: itemList,
							requestedAction,
							status: "ok",
						};
					case 99:
						return {
							data,
							requestedAction,
							status: "ko",
						};
				}
			}
		});
	}

	async saveMulti (itemList) {
		let actions = new Set();

		if (!Array.isArray(itemList)) {
			itemList = [itemList];
		}

		const itemsToInsert = [];
		const itemsToUpdate = [];

		itemList.forEach(item => {
			actions.add(item.guid === "" ? "insert" : "update");
			if (item.guid === "") {
				itemsToInsert.push(item);
			}
			else {
				itemsToUpdate.push(item);
			}
		});

		// if (actions.size > 1) {
		// 	// Dave: A tendere, anziché dare errore dovrei raggruppare una chiamata per insert e una per update
		// 	alert("Non posso proseguire perché hai mescolato insert e update")
		// 	return;
		// }
		
		// const rd = NousCore.api.createRequest({ item: itemList[0].export() });
		let insertPromise;
		let updatePromise;

		if (itemsToInsert.length > 0) {
			const rd = NousCore.api.createRequest({ items: itemsToInsert.map(item => item.export()) });
			const requestedAction = "insert";

			insertPromise = NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
			.then(data => {
				if (data.isSuccess) {
					switch (data.rc) {
						case 1:
							itemsToInsert.forEach((item, index) => {
								item.import(data.items[index]);
								item.clean();
							});

							return {
								data: itemsToInsert,
								requestedAction,
								status: "ok",
							};
						case 99:
							return {
								data,
								requestedAction,
								status: "ko",
							};
					}
				}
			});
		}
		if (itemsToUpdate.length > 0) {
			const rd = NousCore.api.createRequest({ items: itemsToUpdate.map(item => item.export()) });
			const requestedAction = "update";

			updatePromise = NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
			.then(data => {
				if (data.isSuccess) {
					switch (data.rc) {
						case 1:
							itemsToUpdate.forEach((item, index) => {
								item.import(data.items[index]);
								item.clean();
							});

							return {
								data: itemsToUpdate,
								requestedAction,
								status: "ok",
							};
						case 99:
							return {
								data,
								requestedAction,
								status: "ko",
							};
					}
				}
			});
		}

		return Promise.all([insertPromise, updatePromise])
		.then(results => {
			return {
				insertResult: results[0],
				updateResult: results[1],
			};
		});
	}



	async upload (target) {
	
		//NousCore.api.on("singleUploadCompleted", this.uploadManager_singleUploadCompletedHandler);
		//waitBoxComponent.setLabel(`Inviati: 0/${target.files.length}`);

		return NousCore.api.uploadFiles(target, "attachment/upload")
		.then((jsonData) => {
			console.log({jsonData});

			const savedFiles = jsonData.payload.items;
			const documents = [];
	
			console.log({savedFiles});

			savedFiles.forEach(savedFile => {
				switch (savedFile.rc) {
					case 1: {
						const newDocument = new Attachment({
							fileSize: savedFile.size,
							fileType: savedFile.type,
							fileURL: savedFile.attemptedSavePath,
							name: savedFile.name,
							revision: 0,
							status: 1,
							thumbnailURL: savedFile.thumbnailURL || "",
						});
	
						documents.push(newDocument);
						break;
					}
					case 95:
						break;
					default:
						alert("Attezione, si è verificato il seguente errore:\n\n" + savedFile.errors[0].errorDescription);
				}
			});
	
			return {
				data: documents,
				status: "ok"
			};
		});
	}

}

export default ManagerBase;
